import { render, staticRenderFns } from "./RedeliveryRequestQuickView.vue?vue&type=template&id=a5090e74&scoped=true&"
import script from "./RedeliveryRequestQuickView.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestQuickView.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestQuickView.vue?vue&type=style&index=0&id=a5090e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5090e74",
  null
  
)

export default component.exports